import { useCallback } from "react";

import { useMutation } from "@apollo/client";

import { type CreateLensSpaceMutation, createLensSpace } from "../../submit/api/mutation";
import { getOrganizations, getRoles } from "../api/queries";
import { type ApolloResult } from "../models/ApolloResult";

export const useCreateLensFolder = (
    organizationId: string,
    lensSpaceName: string,
): ApolloResult<{
    createLensFolder: () => Promise<void>;
}> => {
    const [createLensFolderAction, { loading, error }] = useMutation<CreateLensSpaceMutation>(createLensSpace, {
        refetchQueries: [
            { query: getRoles },
            {
                query: getOrganizations,
            },
        ],
    });

    const performCreateLensFolderAction = useCallback(async () => {
        if (!lensSpaceName || loading) {
            return;
        }

        await createLensFolderAction({ variables: { organizationId, lensSpaceName } });
        //TODO handle error from Create Lens Folder Mutation if failed
    }, [createLensFolderAction, organizationId, loading, lensSpaceName]);

    return { createLensFolder: performCreateLensFolderAction, loading, error };
};
